// react
import type { ReactNode } from 'react';

// feature-components
import ElectricitySystem from '@/features/alarm-hub/components/alarmType/electricitySystem/ElectricitySystem';
import EnergyXplorerOperations from '@/features/alarm-hub/components/alarmType/energyXplorerOperations/EnergyXplorerOperations';
import ExternalSensorDown from '@/features/alarm-hub/components/alarmType/ExternalSensorDown.tsx';
import FastSensorDown from '@/features/alarm-hub/components/alarmType/FastSensorDown.tsx';
import HeatingSystem from '@/features/alarm-hub/components/alarmType/HeatingSystem';
import QualityOfServiceDataStream from '@/features/alarm-hub/components/alarmType/qualityOfServiceDataStream/QualityOfServiceDataStream';
import SeepLeakage from '@/features/alarm-hub/components/alarmType/seepLeakage/SeepLeakage';
import SensorDown from '@/features/alarm-hub/components/alarmType/SensorDown.tsx';
import ThresholdLimit from '@/features/alarm-hub/components/alarmType/thresholdLimit/ThresholdLimit';
import UsageOverTime from '@/features/alarm-hub/components/alarmType/usageOverTime/UsageOverTime';
import type { LegacyAlarmShape } from '@/features/alarm-hub/components/alarmTypeVisualizationShared.ts';

function renderAlarmTypeVisualization(
  alarmType: string | null | undefined,
  alarm: LegacyAlarmShape,
): ReactNode {
  switch (alarmType) {
    case 'HeatingSystem':
      return <HeatingSystem alarm={alarm} />;
    case 'SeepLeakage':
      return <SeepLeakage alarm={alarm} />;
    case 'EnergyXOperations':
      return <EnergyXplorerOperations alarm={alarm} />;
    case 'ElectricitySystem':
      return <ElectricitySystem alarm={alarm} />;
    case 'SensorDown':
      return <SensorDown alarm={alarm} />;
    case 'FastSensorDown':
      return <FastSensorDown alarm={alarm} />;
    case 'ExternalSensorDown':
      return <ExternalSensorDown alarm={alarm} />;
    case 'ThresholdLimit':
      return <ThresholdLimit alarm={alarm} />;
    case 'UsageOverTime':
      return <UsageOverTime alarm={alarm} />;
    case 'QualityOfServiceDataStream':
      return <QualityOfServiceDataStream alarm={alarm} />;
    default:
      return alarmType ?? null;
  }
}

type AlarmTypeVisualizationProps = {
  alarm: LegacyAlarmShape | null;
};

export default function AlarmTypeVisualization({
  alarm,
}: AlarmTypeVisualizationProps) {
  if (!alarm) {
    return null;
  }

  return renderAlarmTypeVisualization(alarm.AlarmType, alarm);
}
